"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoService = void 0;
const oidc_client_1 = require("oidc-client");
const common_1 = require("./common");
/**
 * Returns UserInfo response
 * So we can fetch updated UserInfo tokens whenever we need to -
 * Check if roles have changed or similar
 *
 * Backed by oidc-client if on browser, openid-client if in Node
 */
class UserInfoService extends common_1.AbstractUserInfoService {
    constructor(authorityOrSettings) {
        super(authorityOrSettings);
        this.underlyingService = null;
    }
    async init() {
        if (this.underlyingService === null) {
            // this is not currently exposed by oidc-client but may be so
            // in future releases - it is nevertheless useful to be able
            // to refetch user info for a new access token when refreshing
            /* eslint-disable @typescript-eslint/no-explicit-any */
            const client = new oidc_client_1.OidcClient({
                authority: this.authority,
                // just fetching userinfo requires no state, but leaving
                // the default implementation causes issues for mobile-app
                // because localStorage is not defined
                stateStore: {
                    get: () => Promise.resolve(null),
                    getAllKeys: () => Promise.resolve([]),
                    set: () => Promise.resolve(),
                    remove: () => Promise.resolve(),
                },
            });
            this.underlyingService = client._validator._userInfoService;
        }
    }
    async getUserInfo(accessToken) {
        await this.init();
        if (this.underlyingService !== null) {
            return this.underlyingService.getClaims(accessToken);
        }
        else {
            throw new Error("Failed to initialize fetcher");
        }
    }
}
exports.UserInfoService = UserInfoService;
